// cases.queryKeys.ts
export const CASE_KEYS = {
    base: ['cases'] as const,
    lists: () => [...CASE_KEYS.base, 'list'] as const,
    list: (filters?: Record<string, unknown>) =>
        [...CASE_KEYS.lists(), filters ? { ...filters } : null] as const,
    details: () => [...CASE_KEYS.base, 'detail'] as const,
    detail: (id: string) => [...CASE_KEYS.details(), id] as const,
};
